import { Action } from "@ngrx/store";

export const GET_ONBOARDING = "[Onboarding Method] GetOnboarding";

export class GetOnboarding implements Action {
  readonly type = GET_ONBOARDING;
}

export type OnboardingActions = GetOnboarding;
